<template>
  <div>
    <Table  ref="currentRowTable" :columns="columns3" :data="data1" size="small" style="border:1px solid #ff9900" :show-header='headerShow'></Table>
  </div>
</template>
<script>
export default {
  name: 'expandTable',
  props: {
    row: Object,
  },
  data() {
    return {
      columns3: this.mockTableHeader(),
      data1: this.mockTableRows(),
      headerShow: false,
    }
  },
  inject: ['CreatePage'],
  methods: {
    mockTableHeader() {
      let da = [];
      let items = this.row.children.header;
      if (items == undefined || items.length === 0) { return } //此行的children无数据
      for (var i = 0; i < items.length; i++) {
        if (items[i].key == "filename") {
          da.push({
            title: items[i].title,
            key: items[i].key,
            width: items[i].width,
            align: items[i].align,
            render: (h, params) => {
              const row = params.row;
              const text = row.filename;
              const fileid = row.fileid;
              return h('a', {
                on: {
                  'click': () => {
                    this.add(fileid, 1);
                    // this.showfilename=true;
                  }
                },
                style: {
                  //fontSize:'16px'
                  // height: '48px',
                  // width: '141px',
                  //color:'red',
                },
              }, text);
            }
          })

        } else {
          da.push({
            title: items[i].title,
            key: items[i].key,
            width: items[i].width,
            align: items[i].align,
          })
        }

      }
      return da;
    },
    add(fid, orderid) {
      this.CreatePage(fid, orderid);
    },
    mockTableRows() {
      let rows = this.row.children.tabrows;
      return rows;
    },
  }
}

</script>
<style scoped>
.expand-row {
  /*margin-bottom: 16px;*/
}

td.ivu-table-expanded-cell {
  padding: 10px 10px;
  background: #f8f8f9;
}

html,
body {
  /*background-color: white;*/
}

</style>
